/**
 * Route for `fraud-alert-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FraudAlertWidgetPage } from "../features/fraud-alert-widget/FraudAlertWidgetPage";

export const fraudAlertWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fraud-alert-widget",
	component: FraudAlertWidgetPage,
});

export default fraudAlertWidgetRoute;
